import React from 'react';
import { Modal, Form, Select, Upload, Button, Input, Space, Checkbox } from 'antd';
import { InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { showSuccessNotification, showWarningNotification, showErrorNotification } from '../../utils/notifications';
const storage = getStorage();
const db = getFirestore();

const DeclineModal = ({ isVisible, onSubmit, onCancel, declineNote, setDeclineNote, handleImageUpload, handleRemoveImage, nameProduct, noteId }) => {
    const [isCompressing, setIsCompressing] = React.useState(false);
    const [isCompressingReference, setIsCompressingReference] = React.useState(false);
    const [form] = Form.useForm();

    const compressImage = (file, quality) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const scale = 0.7;
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob((blob) => {
                        const compressedFile = new File(
                            [blob],
                            file.name.replace(/\.\w+$/, '.jpg'),
                            { type: 'image/jpeg' }
                        );
                        resolve(compressedFile);
                    }, 'image/jpeg', quality);
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        });
    };

    return (
        // Modal per il decline della variante
        <Modal
            title="Decline Variant"
            open={isVisible}
            onOk={() => {
                form.validateFields()
                    .then(values => {
                        // Assicuriamoci che causeDeclination sia un array
                        // e non usiamo il valore dal form, ma quello che abbiamo gestito manualmente
                        const updatedNote = {
                            ...declineNote,
                            // Non prendiamo causeDeclination da values ma usiamo quello che abbiamo gestito manualmente
                            // causeDeclination: values.causeDeclination,
                            referenceImageCorrect: declineNote.referenceImageCorrect || []
                        };

                        // Verifichiamo che causeDeclination sia un array valido
                        if (!Array.isArray(updatedNote.causeDeclination) || updatedNote.causeDeclination.length === 0) {
                            form.setFields([
                                {
                                    name: 'causeDeclination',
                                    errors: ['Please select at least one reason for declination']
                                }
                            ]);
                            return;
                        }

                        // Verifichiamo se c'è "Other" nell'array causeDeclination
                        if (updatedNote.causeDeclination.includes("Other")) {
                            if (!updatedNote.customReason?.trim()) {
                                form.setFields([
                                    {
                                        name: 'customReason',
                                        errors: ['Please specify the other reason']
                                    }
                                ]);
                                return;
                            }

                            // Sostituiamo "Other" con il valore personalizzato
                            const standardValues = ["Incorrect Reference Image", "Incorrect Original 3D Model", "Missing or Incomplete Textures", "Dimension or Scale Discrepancy", "Model Image Discrepancy"];
                            const causes = [...updatedNote.causeDeclination];
                            const standardCauses = causes.filter(item => standardValues.includes(item));

                            updatedNote.causeDeclination = [...standardCauses, updatedNote.customReason];
                        }

                        // Rimuoviamo customReason prima del salvataggio dato che il valore è già in causeDeclination
                        const { customReason, ...noteToSave } = updatedNote;

                        // Call onSubmit with the cleaned note
                        onSubmit(noteToSave);
                    })
                    .catch(error => {
                        // Form validation failed, do nothing as the form will show the errors
                        console.warn('Validation failed:', error);
                    });
            }}
            onCancel={onCancel}
            okText="Save"
            cancelText="Cancel"
            width={700}
            styles={{ body: { padding: 0 } }}
        >
            <Form form={form} layout="vertical" style={{ width: '100%' }}>
                <Space direction="vertical" style={{ width: '100%' }} size="large">
                    <div>
                        {/* Data di decline */}
                        <label>Date:</label>
                        <Input
                            value={declineNote.date?.toDate ? declineNote.date.toDate().toLocaleString() : new Date().toLocaleString()}
                            disabled
                            style={{ backgroundColor: '#f5f5f5', color: 'rgba(0, 0, 0, 0.65)' }}
                        />
                    </div>
                    <div>
                        {/* SKU Model */}
                        <label>SKU Model:</label>
                        <Input
                            value={declineNote.skuModel}
                            disabled
                            style={{ backgroundColor: '#f5f5f5', color: 'rgba(0, 0, 0, 0.65)' }}
                        />
                    </div>

                    <Form.Item
                        label="Issue Title:"
                        name="issueTitle"
                        initialValue={declineNote.issueTitle || ''}
                        rules={[{ required: true, message: 'Please enter an issue title' }]}
                    >
                        <Input
                            value={declineNote.issueTitle}
                            onChange={e => setDeclineNote(prev => ({ ...prev, issueTitle: e.target.value }))}
                            placeholder="Enter a concise title for the issue (e.g. 'Misaligned wheel axle')."
                            className="normal-input"
                            style={{ backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Reason(s) for Decline:"
                        name="causeDeclination"
                        initialValue={declineNote.causeDeclination || []}
                        rules={[{ required: true, message: 'Please select at least one reason for declination' }]}
                    >
                        <Checkbox.Group
                            value={declineNote.causeDeclination?.map(item => {
                                // Verifichiamo se è un valore personalizzato (non standard)
                                const standardValues = ["Incorrect Reference Image", "Incorrect Original 3D Model", "Missing or Incomplete Textures", "Dimension or Scale Discrepancy", "Model Image Discrepancy"];
                                return !standardValues.includes(item) ? "Other" : item;
                            }) || []}
                            onChange={(checkedValues) => {
                                // Gestiamo i valori selezionati
                                let newValues = [...checkedValues];

                                // Se "Other" è selezionato, manteniamo "Other" temporaneamente
                                if (checkedValues.includes("Other")) {
                                    // Rimuoviamo "Other" dall'array
                                    newValues = newValues.filter(v => v !== "Other");
                                    // Aggiungiamo "Other" temporaneamente, verrà sostituito quando l'utente digiterà il valore
                                    newValues.push("Other");
                                }

                                setDeclineNote(prev => ({ ...prev, causeDeclination: newValues }));
                            }}
                            style={{ width: '100%' }}
                        >
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <div style={{ display: 'flex', width: '100%', marginBottom: '8px' }}>
                                    <div style={{ flex: '1', marginRight: '16px' }}>
                                        <Checkbox value="Incorrect Reference Image">
                                            Incorrect Reference Image
                                        </Checkbox>
                                    </div>
                                    <div style={{ flex: '1' }}>
                                        <Checkbox value="Incorrect Original 3D Model">
                                            Incorrect Original 3D Model
                                        </Checkbox>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', width: '100%', marginBottom: '8px' }}>
                                    <div style={{ flex: '1', marginRight: '16px' }}>
                                        <Checkbox value="Missing or Incomplete Textures">
                                            Missing or Incomplete Textures
                                        </Checkbox>
                                    </div>
                                    <div style={{ flex: '1' }}>
                                        <Checkbox value="Dimension or Scale Discrepancy">
                                            Dimension or Scale Discrepancy
                                        </Checkbox>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', width: '100%', marginBottom: '8px' }}>
                                    <div style={{ flex: '1', marginRight: '16px' }}>
                                        <Checkbox value="Model Image Discrepancy">
                                            Model Image Discrepancy
                                        </Checkbox>
                                    </div>
                                    <div style={{ flex: '1' }}>
                                        <Checkbox value="Other">
                                            Other
                                        </Checkbox>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        <div style={{ flex: '1' }}>
                                            {/* Spazio vuoto per il layout */}
                                        </div>
                                        <div style={{ flex: '1' }}>
                                            {/* Spazio vuoto per bilanciare il layout */}
                                        </div>
                                    </div>
                                    {declineNote.causeDeclination?.includes("Other") && (
                                        <Form.Item
                                            name="customReason"
                                            style={{ marginTop: 8, marginBottom: 0 }}
                                            rules={[{ required: true, message: 'Please specify the other reason' }]}
                                        >
                                            <Input
                                                placeholder="Please specify the other reason"
                                                value={declineNote.customReason || ''}
                                                onChange={e => {
                                                    const newValue = e.target.value;
                                                    setDeclineNote(prev => ({
                                                        ...prev,
                                                        customReason: newValue
                                                    }));
                                                }}
                                                className="normal-input"
                                                style={{ backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }}
                                            />
                                        </Form.Item>
                                    )}
                                </div>
                            </div>
                        </Checkbox.Group>
                    </Form.Item>

                    <Form.Item
                        label="Detailed Change Request:"
                        name="description"
                        rules={[{ required: true, message: 'Please enter detailed and precise change requests for the 3D model' }]}
                        initialValue={declineNote.description}
                    >
                        <Input.TextArea
                            value={declineNote.description}
                            onChange={e => setDeclineNote(prev => ({ ...prev, description: e.target.value }))}
                            placeholder="Please enter detailed and precise change requests for the 3D model here"
                            rows={4}
                            className="normal-input"
                            style={{ backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.85)' }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Severity:"
                        name="severity"
                        initialValue={declineNote.severity || undefined}
                        rules={[{ required: true, message: 'Please select the severity level' }]}
                    >
                        <Select
                            placeholder="Select severity level"
                            value={declineNote.severity}
                            onChange={value => setDeclineNote(prev => ({ ...prev, severity: value }))}
                            style={{ color: 'rgba(0, 0, 0, 0.85)' }}
                        >
                            <Select.Option value="Minor">
                                <span style={{ backgroundColor: '#d9f7be', padding: '2px 8px', borderRadius: '4px' }}>Minor (cosmetic)</span>
                            </Select.Option>
                            <Select.Option value="Major">
                                <span style={{ backgroundColor: '#fff1b8', padding: '2px 8px', borderRadius: '4px' }}>Major (functional)</span>
                            </Select.Option>
                            <Select.Option value="Critical">
                                <span style={{ backgroundColor: '#ffccc7', padding: '2px 8px', borderRadius: '4px' }}>Critical (blocking)</span>
                            </Select.Option>
                        </Select>
                    </Form.Item>

                    {declineNote.causeDeclination?.includes("Incorrect Reference Image") && (
                        <Form.Item
                            label="Correct Reference Image(s):"
                            name="referenceImageCorrect"
                            rules={[{ required: true, message: 'Please upload at least one correct reference image' }]}
                            initialValue={declineNote.referenceImageCorrect || []}
                        >
                            <Upload
                                name="referenceFiles"
                                beforeUpload={async (file) => {
                                    if (declineNote.referenceImageCorrect && declineNote.referenceImageCorrect.length >= 4) {
                                        showWarningNotification('You can upload up to 4 reference images only.');
                                        return Upload.LIST_IGNORE;
                                    }

                                    const sizeInMB = file.size / 1024 / 1024;
                                    if (sizeInMB > 4) {
                                        showErrorNotification(`${file.name} exceeds the 4MB limit.`);
                                        return Upload.LIST_IGNORE;
                                    }

                                    let quality = 1;
                                    const sizeInKB = file.size / 1024;

                                    if (sizeInKB >= 300 && sizeInKB < 1024) quality = 0.6;
                                    else if (sizeInKB >= 1024 && sizeInKB < 2048) quality = 0.5;
                                    else if (sizeInKB >= 2048 && sizeInKB < 3072) quality = 0.4;
                                    else if (sizeInKB >= 3072) quality = 0.35;

                                    if (quality < 1) {
                                        setIsCompressingReference(true);
                                        const compressedFile = await compressImage(file, quality);
                                        setIsCompressingReference(false);
                                        return compressedFile;
                                    }

                                    return file;
                                }}
                                customRequest={({ file, onSuccess }) => {
                                    if (!nameProduct || !declineNote.skuModel) {
                                        showErrorNotification('Product name or SKU model is not defined.');
                                        return;
                                    }
                                    const skuModel = declineNote.skuModel.replace(/\s+/g, '_').replace(/\//g, '_');
                                    const formattedNameProduct = nameProduct.replace(/\s+/g, '_').replace(/\//g, '_');

                                    // Create a path for reference images
                                    const storagePath = `ValidationNotesImages/${formattedNameProduct}-${skuModel}/referenceImage`;

                                    // Add timestamp to filename to avoid overwrites
                                    const timestamp = new Date().getTime();
                                    const fileName = `${timestamp}_${file.name}`;

                                    const storageRef = ref(storage, `${storagePath}/${fileName}`);

                                    uploadBytes(storageRef, file).then((snapshot) => {
                                        getDownloadURL(snapshot.ref).then(async (downloadURL) => {
                                            // Add URL to the referenceImageCorrect array
                                            setDeclineNote(prev => ({
                                                ...prev,
                                                referenceImageCorrect: [...(prev.referenceImageCorrect || []), downloadURL]
                                            }));

                                            onSuccess("ok");
                                            showSuccessNotification(`Reference image ${file.name} uploaded successfully`);
                                        });
                                    }).catch((error) => {
                                        showErrorNotification(`Error uploading reference image: ${error.message}`);
                                    });
                                }}
                                multiple={true}
                                accept="image/*"
                                showUploadList={false}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '10px 16px',
                                    border: '1px dashed #d9d9d9',
                                    borderRadius: '8px',
                                    background: '#fafafa',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s'
                                }}
                                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#1890ff'}
                                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#d9d9d9'}
                                >
                                    <InboxOutlined style={{ fontSize: '20px', color: '#1890ff', marginRight: '8px' }} />
                                    <span style={{ flex: 1 }}>Upload reference images</span>
                                    <span style={{ color: '#8c8c8c', fontSize: '12px', backgroundColor: '#f0f0f0', padding: '2px 8px', borderRadius: '10px', marginLeft: '12px' }}>Max 4</span>
                                </div>
                            </Upload>
                            {isCompressingReference && (
                                <div style={{ textAlign: 'center', marginTop: 8 }}>
                                    <span>Compressing reference image...</span>
                                </div>
                            )}

                            {/* Show uploaded reference images */}
                            {declineNote.referenceImageCorrect && declineNote.referenceImageCorrect.length > 0 && (
                                <div style={{ marginTop: 16 }}>
                                    <label>Uploaded Reference Images:</label>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
                                        {declineNote.referenceImageCorrect.map((img, index) => (
                                            <div key={index} style={{ position: 'relative', width: 100, height: 100 }}>
                                                <img
                                                    src={img}
                                                    alt={`Reference Image ${index + 1}`}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: 4
                                                    }}
                                                />
                                                <Button
                                                    type="primary"
                                                    danger
                                                    icon={<DeleteOutlined />}
                                                    size="small"
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                        borderRadius: '50%',
                                                        padding: 0,
                                                        width: 24,
                                                        height: 24,
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center'
                                                    }}
                                                    onClick={() => {
                                                        const updatedImages = [...(declineNote.referenceImageCorrect || [])];
                                                        updatedImages.splice(index, 1);
                                                        setDeclineNote(prev => ({ ...prev, referenceImageCorrect: updatedImages }));
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </Form.Item>
                    )}
                    <div>
                        {/* Upload delle immagini */}
                        <Form.Item label="Optional file upload for screenshots:" style={{ marginBottom: '12px' }}>
                            <Upload
                                name="files"
                                beforeUpload={async (file) => {
                                    if (declineNote.images.length >= 4) {
                                        showWarningNotification('You can upload up to 4 images only.');
                                        return Upload.LIST_IGNORE;
                                    }

                                    const sizeInMB = file.size / 1024 / 1024;
                                    if (sizeInMB > 4) {
                                        showErrorNotification(`${file.name} exceeds the 4MB limit.`);
                                        return Upload.LIST_IGNORE;
                                    }

                                    let quality = 1;
                                    const sizeInKB = file.size / 1024;

                                    if (sizeInKB >= 300 && sizeInKB < 1024) quality = 0.6; // 300-1024kb 60% compressione del 40%
                                    else if (sizeInKB >= 1024 && sizeInKB < 2048) quality = 0.5; // 1024-2048kb 50% compressione del 50%
                                    else if (sizeInKB >= 2048 && sizeInKB < 3072) quality = 0.4; // 2048-3072kb 40% compressione del 60%
                                    else if (sizeInKB >= 3072) quality = 0.35; // 3072kb 35% compressione del 65%

                                    if (quality < 1) {
                                        setIsCompressing(true);
                                        const compressedFile = await compressImage(file, quality);
                                        setIsCompressing(false);
                                        return compressedFile;
                                    }

                                    return file;
                                }}
                                customRequest={({ file, onSuccess }) => {
                                    if (!nameProduct || !declineNote.skuModel) {
                                        showErrorNotification('Product name or SKU model is not defined.');
                                        return;
                                    }
                                    const skuModel = declineNote.skuModel.replace(/\s+/g, '_').replace(/\//g, '_');
                                    const formattedNameProduct = nameProduct.replace(/\s+/g, '_').replace(/\//g, '_');

                                    // Creiamo un percorso unico per ogni occhiale usando nameProduct e skuModel
                                    const storagePath = `ValidationNotesImages/${formattedNameProduct}-${skuModel}`;

                                    // Aggiungiamo un timestamp al nome del file per evitare sovrascritture
                                    const timestamp = new Date().getTime();
                                    const fileName = `${timestamp}_${file.name}`;

                                    const storageRef = ref(storage, `${storagePath}/${fileName}`);

                                    uploadBytes(storageRef, file).then((snapshot) => {
                                        getDownloadURL(snapshot.ref).then(async (downloadURL) => {
                                            // Aggiungiamo l'URL all'array di immagini
                                            setDeclineNote(prev => ({
                                                ...prev,
                                                images: [...(prev.images || []), downloadURL]
                                            }));

                                            onSuccess("ok");
                                            showSuccessNotification(`Image ${file.name} uploaded successfully`);
                                        });
                                    }).catch((error) => {
                                        showErrorNotification(`Error uploading image: ${error.message}`);
                                    });
                                }}
                                multiple={true}
                                accept="image/*"
                                showUploadList={false}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '10px 16px',
                                    border: '1px dashed #d9d9d9',
                                    borderRadius: '8px',
                                    background: '#fafafa',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s'
                                }}
                                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#1890ff'}
                                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#d9d9d9'}
                                >
                                    <InboxOutlined style={{ fontSize: '20px', color: '#1890ff', marginRight: '8px' }} />
                                    <span style={{ flex: 1 }}>Upload screenshots</span>
                                    <span style={{ color: '#8c8c8c', fontSize: '12px', backgroundColor: '#f0f0f0', padding: '2px 8px', borderRadius: '10px', marginLeft: '12px' }}>Max 4</span>
                                </div>
                            </Upload>
                        </Form.Item>
                        {isCompressing && (
                            <div style={{ textAlign: 'center', marginTop: 8 }}>
                                <span>Compressing image...</span>
                            </div>
                        )}
                    </div>
                    {/* Show uploaded images */}
                    {declineNote.images.length > 0 && (
                        <div style={{ marginTop: 16 }}>
                            <label>Uploaded Images:</label>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 8 }}>
                                {declineNote.images.map((img, index) => (
                                    <div key={index} style={{ position: 'relative', width: 100, height: 100 }}>
                                        <img
                                            src={img}
                                            alt={`Image ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                borderRadius: 4
                                            }}
                                        />
                                        <Button
                                            type="primary"
                                            danger
                                            icon={<DeleteOutlined />}
                                            size="small"
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                borderRadius: '50%',
                                                padding: 0,
                                                width: 24,
                                                height: 24,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center'
                                            }}
                                            onClick={() => handleRemoveImage(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </Space>
            </Form>
        </Modal>
    );
};

export default DeclineModal;